import axios from "axios";

// Action Types
export const FETCH_DRS_EBT_LOGS_REQUEST = "FETCH_DRS_EBT_LOGS_REQUEST";
export const FETCH_DRS_EBT_LOGS_SUCCESS = "FETCH_DRS_EBT_LOGS_SUCCESS";
export const FETCH_DRS_EBT_LOGS_FAILURE = "FETCH_DRS_EBT_LOGS_FAILURE";

// Action Creators
export const fetchDrsEbtLogsRequest = () => ({
  type: FETCH_DRS_EBT_LOGS_REQUEST,
});

export const fetchDrsEbtLogsSuccess = (data, total) => ({
  type: FETCH_DRS_EBT_LOGS_SUCCESS,
  payload: {
    data,
    total
  }
});

export const fetchDrsEbtLogsFailure = (error) => ({
  type: FETCH_DRS_EBT_LOGS_FAILURE,
  payload: error
});

// Thunk Action Creator
export const fetchDrsEbtLogs = (query) => {
  return async (dispatch) => {
    dispatch(fetchDrsEbtLogsRequest());
    try {
      if (!query) {
        query = "?license=0";
      } else {
        query += "&license=0";
      }
      const response = await axios.get(`/ebt_logs${query}`);
      dispatch(fetchDrsEbtLogsSuccess(response.data.data, response.data.total));
    } catch (error) {
      dispatch(fetchDrsEbtLogsFailure(error.message));
    }
  };
};